<script setup>
  import ListeUtilisateurs from '@/components/ListeUtilisateurs.vue'

</script>

<template>
  <h1>Liste des utilisateurs</h1>
  <div class="utilisateurs">
    
    <ListeUtilisateurs/>
  </div>
</template>

<script>


export default {

}
</script>

<style>


</style>
